export const wordsList = {
  carro: ["Motor", "Porta", "Capô", "Pneu", "Antena", "Volante", "Banco"],
  fruta: ["Banana", "Maça", "Pêra", "Mamão", "Laranja", "Uva", "Melancia"],
  corpo: ["Braço", "Perna", "Cérebro", "Pescoço", "Olhos", "Peito", "Mao"],
  computador: ["Mouse", "Teclado", "Monitor", "Gabinete", "Cooler", "Phone"],
  programação: ["Linguagem", "Framework", "JavaScript", "React", "HTML", "Bootstrap"],
  alimento: ["Arroz", "Feijão", "Carne", "Leite", "Ovo"],
  nomes: ["Lucas", "Stefany", "Pyetra", "Luana", "Sophia", "Florenca"]
}; 